import React from "react";

export default function TransactionCard({ tx, onClick, displayTotal, totalLabel }) {
    // Format date and time (use created_at from backend)
    const dateObj = new Date(tx.created_at);
    const dateStr = isNaN(dateObj) ? '-' : dateObj.toLocaleDateString();
    const timeStr = isNaN(dateObj) ? '-' : dateObj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const products = Array.isArray(tx.products) ? tx.products : [];
    const categories = Array.from(
        new Set(
            products
                .map(item => (item?.category || "").trim())
                .filter(Boolean)
        )
    );

    return (
        <div
            className="rounded-xl p-2 w-full sm:max-w-xs flex-1 shadow-sm cursor-pointer transition hover:shadow-md bg-white border border-gray-200"
            onClick={e => {
                if (e.target.tagName === 'BUTTON') return;
                if (onClick) onClick();
            }}
            tabIndex={0}
            role="button"
            aria-label={`View details for order ${tx.order_number}`}
        >
            {/* Order Number, Status, and Branch Row */}
            <div className="flex justify-between items-center mb-1">
                <span className="font-semibold text-xs text-gray-800 truncate" title={`Order #${tx.order_number}`}>#{tx.order_number}</span>
                <span className={`text-[10px] font-semibold rounded px-1 py-0.5 ${tx.status === 'Completed' ? 'bg-green-100 text-green-700' : tx.status === 'Pending' ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-200 text-gray-700'}`}>{tx.status}</span>
            </div>
            {/* Branch Name */}
            {tx.branch_name && (
                <div className="text-[10px] text-gray-500 mb-1 italic truncate">{tx.branch_name}</div>
            )}
            {/* Date, Time, Payment */}
            <div className="flex justify-between text-[10px] text-gray-500 mb-1">
                <span>{dateStr}</span>
                <span>{timeStr}</span>
                <span className="italic">{tx.payment_method}</span>
            </div>
            {/* Products (inline, compact) */}
            {products.length > 0 && (
                <div className="text-[11px] text-gray-700 mb-1 truncate">
                    {products.slice(0, 3).map((item, idx) => (
                        <span key={idx} className="mr-2">
                            {item.name || "Item"} <span className="text-gray-500">x{item.qty || 1}</span>{idx < Math.min(products.length, 3) - 1 ? ',' : ''}
                        </span>
                    ))}
                    {products.length > 3 && <span className="text-gray-400">+{products.length - 3} more</span>}
                </div>
            )}
            {categories.length > 0 && (
                <div className="text-[10px] text-gray-500 mb-1 truncate">
                    {categories.length === 1 ? "Category:" : "Categories:"}{" "}
                    <span className="text-gray-700">{categories.join(", ")}</span>
                </div>
            )}
            {/* Total Amount Paid */}
            <div className="flex justify-between items-center mt-1">
                <span className="text-[11px] text-gray-500">
                    {totalLabel ? `${totalLabel}: ` : ""}
                    {"\u20b1"}{Number.isFinite(Number(displayTotal)) ? Number(displayTotal).toLocaleString() : Number(tx.total).toLocaleString()}
                </span>
                <button
                    tabIndex={0}
                >
                    Details
                </button>
            </div>
        </div>
    );
}
